// This icon file is generated automatically.
var LoadingOutlined = {
  "icon": {
    "tag": "svg",
    "attrs": {
      "viewBox": "0 0 1024 1024",
      "focusable": "false"
    },
    "children": [{
      "tag": "path",
      "attrs": {
        "d": "M512,0 C794.769,0 1024,229.230 1024,512 C1024,548.883 994.1004,578.782 957.21,578.78 C920.33,578.78 890.43,548.88 890.43,512 C890.43,302.99 721.00,133.56 512,133.56 C475.11,133.56 445.21,103.66 445.21,66.78 C445.21,29.89 475.11,0 512,0 Z"
      }
    }]
  },
  "name": "loading",
  "theme": "outlined"
};
var LoadingOutlinedSvg = LoadingOutlined;

export { LoadingOutlinedSvg as default };
